import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>

        <h1 className="project-heading">
          <strong className="purple">Experience</strong>
        </h1>

        <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col  md={"auto"}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
                marginLeft:"50px"
            }}>
                <p style={{fontSize:"20px"}}><strong className="purple">Company : </strong> NajahNow</p>

                <br/>
                <p style={{fontSize:"20px",marginLeft:"80px"}}><strong className="purple">Position : </strong> Full-stack developer</p>

                 <br/>
                <p style={{fontSize:"20px",marginLeft:"40px"}}><strong className="purple">Start-date : </strong> 1 August,2021</p>

            </Col>

            <Col md={"auto"}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}>
                <p style={{fontSize:"20px"}}><strong className="purple">Supervisor : </strong> ITIDA</p>

                <br/>
                <p style={{fontSize:"20px",marginLeft:"90px"}}><strong className="purple">Project : </strong> Islamic Marriage App</p>

                <br/>
                <p style={{fontSize:"20px",marginLeft:"60px"}}><strong className="purple">End-date : </strong> 1 October,2021</p>

            </Col>

        </Row>


        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
